/**
 * File anchor-button.js.
 * Handles scrolling to modules when anchor-button items are clicked
 */

const anchorBtnItems = document.querySelectorAll('.anchor-button');

function scrollToModule(name, index) {
  const selector = ( name == 'module_blocks') ?
    // need to select module inside module-block
    '.module-block[data-name="' + name + '"] .module[data-index="' + index + '"]' :
    // select regular module
    '.module[data-name="' + name + '"][data-index="' + index + '"]';

  const module = document.querySelector(selector);

  module.scrollIntoView({
    behavior: 'smooth' 
  });
}

for (let i = 0, len = anchorBtnItems.length; i < len; i++) {
  const button = anchorBtnItems[i];
  const name = button.dataset.moduleName;
  const index = button.dataset.moduleIndex;

  button.addEventListener('click', function(e) {
    scrollToModule(name, index);
    segmentTrackModuleElementClicked(e, 'LINK');
  });
}
